module.exports = __webpack_public_path__ + "assets/img/year-button-total.7d73123f.png";